GameSlamStopButton = {};

GameSlamStopButton.create = function() {
	var button = new PIXI.Container();

	InputHelpers.addGenerics(button);
	button._flags.reelsSpinning = false;
	button._flags.reelsSlammed = false;
	button._flags.spinEventReceived = false;
	
	button.canEnable = function() {
        if (button._flags.allowSlamStop) {
			this.visible = true;
			return ( gameController._receivedResponse && !this._flags.reelsSlammed && !this._flags.modal.active);			
        } else {
            // Removed slam stop due GC limitations Sept 2020.
			this.visible = false;
            return false;
		}
	};

	button.canShow = function() {
		// this works as slam stop asset is the same as start button - we just never enable the button
		// if GC limitations apply ( see above in canEnable )
		return ( this._flags.reelsSpinning );
	};

	button.onPressedCallback = function() {
		this._flags.reelsSlammed = true;
		gameController.doSlamStop();
	
		if (button.soundName !== "") button.playSound();
	};

	button.reelSpinStarted = function(spinTask) {
		soundManager.play("reelSpin");
		this._flags.reelsSlammed = false;
		this._flags.reelsSpinning = true;
	};

	button.reelSpinEnded = function() {
		soundManager.stop("reelSpin");
		this._flags.reelsSpinning = false;
		this._flags.reelsSlammed = false;		
	};

	button.gameCommitted = function() {
		this._flags.reelsSpinning = true;
		this._flags.reelsSlammed = false;	
	};

	messageBus.subscribe("spinner:SpinEvent", button.reelSpinStarted.bind(button));
	messageBus.subscribe("spinner:SpinEventDead", button.reelSpinEnded.bind(button));
	messageBus.subscribe("common:GameCommitted", button.gameCommitted.bind(button));
    messageBus.subscribe("common:AbortGame", button.reelSpinEnded.bind(button));	
	messageBus.subscribe("common:GameCompleteEvent", button.reelSpinEnded.bind(button));

	return button;
};

GameSlamStopButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
GameSlamStopButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("GameSlamStopButton", GameSlamStopButton.create, GameSlamStopButton.initialise, GameSlamStopButton.getFilesRequired);